// FAQ accordion. Animate a measured px max-height (smooth) rather than an
// intrinsic size like 0fr<->1fr (janky - relayouts every frame). _faq.scss
// keeps the panel at max-height:0; this sets it to scrollHeight on open.
$( function () {
	function setHeight( btn ) {
		const panel = btn.nextElementSibling;
		panel.style.maxHeight =
			btn.getAttribute( 'aria-expanded' ) === 'true' ? panel.scrollHeight + 'px' : '0px';
	}

	$( document ).on( 'click', '.theme-faq-item__question', function () {
		const open = this.getAttribute( 'aria-expanded' ) === 'true';
		this.setAttribute( 'aria-expanded', open ? 'false' : 'true' );
		setHeight( this );
	} );

	// open whatever's already marked expanded server-side (first item, see
	// faq/render.php) - it has aria-expanded="true" but still needs its
	// max-height set.
	$( '.theme-faq-item__question[aria-expanded="true"]' ).each( function () {
		setHeight( this );
	} );

	// keep an open panel's clamp in sync when the text reflows at a new width
	$( window ).on( 'resize', function () {
		$( '.theme-faq-item__question[aria-expanded="true"]' ).each( function () {
			setHeight( this );
		} );
	} );
} );
